import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Modal/ModalContent.js",
  _templateObject,
  _this = this;
import React, { useContext, useState, useEffect, useRef } from 'react';
import { ModalContext } from './Modal';
import { Content, ContentWrapper, ScrollBottomFade } from './styles';
import { withTheme, useTheme } from '../../core/ThemeProvider';
import { withStyledAttrs } from '../../helpers/styled';
import Text from '../Text';
import Spacing from '../Spacing';
var ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
var firefox = ua.match(/firefox/i);
var safariOS = (ua.match(/iPad/i) || ua.match(/iPhone/i)) && ua.match(/WebKit/i) && !ua.match(/CriOS/i);
var Title = withTheme(withStyledAttrs(Text, {
  type: 'sectionTitle'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    max-width: 100%;\n    padding: ", ";\n  "])), function (p) {
  var _p$coreTheme$modal;
  return (_p$coreTheme$modal = p.coreTheme.modal) === null || _p$coreTheme$modal === void 0 ? void 0 : _p$coreTheme$modal.titlePadding;
}));
var ModalContent = function ModalContent(_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    isScrollable = _useState2[0],
    setIsScrollable = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    scrolledBottom = _useState4[0],
    setScrolledBottom = _useState4[1];
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  var contentRef = useRef(null);
  var _useContext = useContext(ModalContext),
    scrollable = _useContext.scrollable,
    visible = _useContext.visible,
    title = _useContext.title,
    hasStickyFooter = _useContext.hasStickyFooter;
  var handleScroll = function handleScroll() {
    var _contentRef$current = contentRef.current,
      scrollTop = _contentRef$current.scrollTop,
      scrollHeight = _contentRef$current.scrollHeight,
      clientHeight = _contentRef$current.clientHeight;
    if (Math.round(scrollTop + clientHeight) >= scrollHeight) {
      setScrolledBottom(true);
    } else {
      setScrolledBottom(false);
    }
  };
  var checkIsScrollable = function checkIsScrollable() {
    var _contentRef$current2 = contentRef.current,
      scrollHeight = _contentRef$current2.scrollHeight,
      clientHeight = _contentRef$current2.clientHeight;
    scrollHeight > clientHeight ? setIsScrollable(true) : setIsScrollable(false);
  };
  useEffect(function () {
    if (contentRef.current && visible) {
      setScrolledBottom(false);
      checkIsScrollable();
      contentRef.current.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', checkIsScrollable);
      return function () {
        contentRef.current.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', checkIsScrollable);
      };
    }
  }, [visible]);
  var renderModalTitle = function renderModalTitle(title) {
    var _theme$modal;
    if (!title) return null;
    if ((_theme$modal = theme.modal) !== null && _theme$modal !== void 0 && _theme$modal.titlePadding) {
      return /*#__PURE__*/React.createElement(Title, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65,
          columnNumber: 14
        }
      }, title);
    }
    return /*#__PURE__*/React.createElement(Spacing, {
      right: '80px',
      bottom: "".concat(theme.space_4, "px"),
      left: 3,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Title, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 9
      }
    }, title));
  };
  var renderModalContent = function renderModalContent(content, title) {
    return /*#__PURE__*/React.createElement(Content, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 5
      }
    }, /*#__PURE__*/React.createElement(Spacing, {
      top: title ? 0 : 3
      /* scrollbar width customisation is not supported in firefox and safari ios, so padding is needed */,

      right: isScrollable && !firefox && !safariOS ? 0 : 3,
      left: 3,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 7
      }
    }, content));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, scrollable ? /*#__PURE__*/React.createElement(Spacing, {
    top: 3,
    bottom: hasStickyFooter ? 0 : 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ContentWrapper, {
    ref: contentRef,
    hasStickyFooter: hasStickyFooter,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 11
    }
  }, renderModalTitle(title), renderModalContent(children, title), !hasStickyFooter && /*#__PURE__*/React.createElement(ScrollBottomFade, {
    isScrollable: isScrollable,
    scrolledBottom: scrolledBottom,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 15
    }
  }))) : /*#__PURE__*/React.createElement(Spacing, {
    top: 3,
    bottom: hasStickyFooter ? 0 : 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 9
    }
  }, renderModalTitle(title), renderModalContent(children, title)));
};
export default ModalContent;